import React from 'react';
import { getConfig } from '../../config/appConfig';
import CandorLogoMark from './CandorLogoMark';

const LoadingScreen = ({ message, subtitle }) => {
  const title = message || getConfig('messages.info.loading');
  const sub = subtitle || `${getConfig('app.name')} · ${getConfig('app.title')}`;
  return (
    <div className="candor-loading-screen">
      <div className="candor-loading-card">
        <div className="candor-loading-logo-wrap">
          <CandorLogoMark size={56} />
        </div>
        <div className="candor-loading-spinner" role="status" aria-label="Loading" />
        <p className="candor-loading-title">{title}</p>
        <p className="candor-loading-subtitle">{sub}</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
